import { getOwner } from 'solid-js';
export default function throwIfNoOwner() {
    if (!getOwner()) {
        throw new Error('(╯°□°)╯︵ ┻━┻');
    }
}
